









import {mapActions, mapGetters} from 'vuex';
import vue from 'vue';
import AdminDialog from '@/components/template/AdminDialog.vue';

interface ComponentData {
  adminDialog: {
    displayed: boolean;
  };
  interval: number | null;
}

export default vue.extend({
  name: 'App',

  components: {AdminDialog},

  data: (): ComponentData => ({
    adminDialog: {
      displayed: false,
    },
    interval: null,
  }),

  computed: {
    ...mapGetters([
      'lastPopMessage',
      'messageUnreadNumber',
    ]),
  },

  created() {
    this.getUsernameInJWT();
    this.loadMessages();
    this.interval = setInterval(this.loadMessages, parseInt(process.env.VUE_APP_MESSAGE_INTERVAL_TIME));
  },

  beforeDestroy() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = null;
    }
  },

  methods: {
    ...mapActions([
      'getUsernameInJWT',
      'loadNewAdminMessages',
      'messageNotReadNumber',
    ]),
    loadMessages(): void {
      this.adminDialog.displayed = false;

      this.messageNotReadNumber()
          .then(() => {
            if (this.messageUnreadNumber !== 0) {
              this.loadNewAdminMessages({types: [2, 3]})
                  .then(() => {
                    if (this.lastPopMessage) {
                      this.adminDialog.displayed = true;
                    }
                  });
            }
          });
    },
  },
});
